import { render } from "./TheWorkFormEditPage.vue?vue&type=template&id=53fb2247"
import script from "./TheWorkFormEditPage.vue?vue&type=script&lang=js"
export * from "./TheWorkFormEditPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__